export function isUltrasoundCapture1(uploadType) {
  if (!uploadType) return false;
  var n = uploadType.toLowerCase().replace(/[\s_-]+/g, "");
  return n.includes("ultrasoundcapture1") || n.includes("ultrasound_capture_1");
}
export function isUltrasoundCapture2(uploadType) {
  if (!uploadType) return false;
  var n = uploadType.toLowerCase().replace(/[\s_-]+/g, "");
  return n.includes("ultrasoundcapture2") || n.includes("ultrasound_capture_2");
}